import { render, staticRenderFns } from "./ReceiptDetail.vue?vue&type=template&id=2cc9e387&scoped=true&"
import script from "./ReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiptDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptDetail.vue?vue&type=style&index=0&id=2cc9e387&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9e387",
  null
  
)

export default component.exports